import XHR         from "_common/xhr";
import { configs } from "_config/index";

export const getDiamondDetails = async function () {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/diamondDetails`
	} );

	return result;
};

export const getPayoutDetailsById = async function ( id ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/payoutDetailsById?payoutId=${ id }`
	} );

	return result;
};

export const getPayoutHistory = async function ( { pageNo, pageSize } ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/payoutHistory?pageNo=${ pageNo }&pageSize=${ pageSize }`
	} );

	return result;
};

export const verifyVPAViaPhone = async function ( mobile ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/vpaFromPhone?phone=${ mobile }`
	} );

	return result;
};

export const verifyPAN = async function ( pan ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/verifyPAN?pan=${ pan }`
	} );

	return result;
};

export const verifyUPI = async function ( upi ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/verifyUpi?upi=${ upi }`
	} );

	return result;
};

export const verifyBankAcc = async function ( { account, ifsc } ) {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/verifyBankAccount?account=${ account }&ifsc=${ ifsc }`
	} );

	return result;
};

export const getPayoutDetails = async function () {
	const result = await XHR.get.bind ( this ) ( {
		url: `${ configs.USER_SRV }payout/payoutDetails`
	} );

	return result;
};

export const savePayoutDetails = async function ( { pan, vpa, ifsc, account } ) {
	const result = await XHR.post.bind ( this ) ( {
		url  : `${ configs.USER_SRV }payout/setPayoutDetails`,
		data : {
			pan              : pan,
			vpa              : vpa,
			ifsc             : ifsc,
			"account_number" : account
		}
	} );

	return result;
};
